"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcAspectRatio = calcAspectRatio;
exports.generateMaxCrop = generateMaxCrop;
const numbers_1 = require("./numbers");
function calcAspectRatio(height, width) {
  return (0, numbers_1.clipFloatingPoint)(height / width);
}
/**
 * @param surface  * @param layer
 * @param imageWidth
 * @param imageHeight
 * @returns
 */
function generateMaxCrop(surface, layer, imageWidth, imageHeight) {
  const wellWidth = surface.width * layer.width;
  const wellHeight = surface.height * layer.height;
  const wellAspectRatio = calcAspectRatio(wellHeight, wellWidth);
  const giAspectRatio = calcAspectRatio(imageHeight, imageWidth);
  const giMiddleX = imageWidth / 2;
  const giMiddleY = imageHeight / 2;
  const giWidthWiderThanWellWidth = giAspectRatio < wellAspectRatio;
  const croppedWidth = giWidthWiderThanWellWidth ? imageHeight * wellWidth / wellHeight : imageWidth;
  const croppedHeight = !giWidthWiderThanWellWidth ? imageWidth * wellHeight / wellWidth : imageHeight;
  const cropData = {
    x: Math.floor(giWidthWiderThanWellWidth ? giMiddleX - croppedWidth / 2 : 0),
    y: Math.floor(!giWidthWiderThanWellWidth ? giMiddleY - croppedHeight / 2 : 0),
    width: Math.floor(croppedWidth),
    height: Math.floor(croppedHeight)
  };
  // Prevents invalid crop resulting from javascript decimal variation
  if (cropData.x < 0) {
    cropData.x = 0;
  }
  if (cropData.y < 0) {
    cropData.y = 0;
  }
  if (cropData.width > imageWidth) {
    cropData.width = imageWidth;
  }
  if (cropData.height > imageHeight) {
    cropData.height = imageHeight;
  }
  return cropData;
}